
import {
  GET_ALL_ORDERS,
  GET_ONE_ORDER_BY_TRIP_ID
} from '../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE
} from '../../utils/status';
import * as orderService from '../../services/order';


// 获取所有订单
export function getAll(show_recommend_trip = 1) {
  return function (dispatch) {
    dispatch({
      type: GET_ALL_ORDERS,
      status: PENDING
    });

    return orderService.getAll(show_recommend_trip)
      .then(function (data) {
        dispatch({
          type: GET_ALL_ORDERS,
          status: SUCCESS,
          data: data
        });

        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_ALL_ORDERS,
          status: FAILURE,
          data: err
        });

        throw err;
      });
  };
}


export function getOneByTripId(trip_id) {
  return function (dispatch) {
    dispatch({
      type: GET_ONE_ORDER_BY_TRIP_ID,
      status: PENDING
    });

    return orderService.getOneByTripId(trip_id)
      .then(function (order) {
        dispatch({
          type: GET_ONE_ORDER_BY_TRIP_ID,
          status: SUCCESS,
          data: order
        });

        return order;
      })
      .catch(function (err) {
        dispatch({
          type: GET_ONE_ORDER_BY_TRIP_ID,
          status: FAILURE,
          data: err
        });

        throw err;
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/order.js